module.exports = __webpack_public_path__ + "static/media/menu-boczne-dziennik_BLUE.57fb6c83.svg";